// Meta Pixel — a base code (init + első PageView) a `public/index.html`
// `<head>` blokkjában van (Facebook útmutatója szerint statikusan).
// Itt csak SPA soft-navigation esetén küldünk plusz PageView-t.
//
// Dupla PageView védelem: a head már fired egy PageView-t a `document`
// betöltéskori pathname-jére. Az első `trackPageView` hívás CSAK akkor
// fire-ol, ha a jelenlegi pathname eltér attól (azaz a user SPA-navigációval
// került egy másik oldalra).

const PIXEL_ID = "158170072678438";
const _firedPaths = new Set();
let _leadFired = false;

export function trackPageView(pathKey = null) {
  if (typeof window === "undefined") return;
  const key = pathKey || (window.location.pathname + window.location.search);
  if (_firedPaths.has(key)) return;

  // Ha a head már fired PageView-t az induló path-re, azt "consume"-oljuk.
  const headPath = window.__mpHeadFiredFor;
  if (headPath && !window.__mpHeadConsumed && window.location.pathname === headPath) {
    window.__mpHeadConsumed = true;
    _firedPaths.add(key);
    return;
  }

  _firedPaths.add(key);
  try {
    if (typeof window.fbq === "function") window.fbq("track", "PageView");
  } catch (_e) { /* silent */ }
}

// Lead event — csak a konverziós (/koszonjuk) oldalon, egyszer per session.
// SPA re-mount és React StrictMode dupla-effekt ellen module-szintű guard véd.
export function trackLead() {
  if (typeof window === "undefined") return;
  if (_leadFired) return;
  _leadFired = true;
  try {
    if (typeof window.fbq === "function") window.fbq("track", "Lead");
  } catch (_e) { /* silent */ }
}

// <noscript> fallback URL a webinar oldalak alján (kompat, a fő noscript
// pixel a public/index.html `<head>`-ben van).
export const METAPIXEL_NOSCRIPT_URL =
  `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
